import { AxesDirective, AxisDirective, LinearGaugeComponent, PointerDirective, PointersDirective } from '@syncfusion/ej2-react-lineargauge/src/linear-gauge';
import React from 'react';
import Constants from '../../models/constants';
import { RatingRange, trackRatingMap } from '../../models/trackRatingMap';
import Weather from '../../models/weather';
import './trackrating.css';

const TrackRating: React.FC<{weather: Weather}> = ({weather}) => {
    const rating: number = weather.goingStick?.thisMeeting?.trackRating ?? 0;
    const ratingMap: RatingRange[] = trackRatingMap.filter(t => t.range[0] <= rating && t.range[1] >= rating);
    const ratingStr: string = ratingMap.length > 0 ? ratingMap[0].rating : '―';
    const backgroundColor: string = ratingStr === 'Firm' ? '#0085C0' : 'Good' ?  '#00961E' : 'Soft' ? Constants.yellow : 'Heavy' ? Constants.orange : 'gray';
        
    return (
        <div className="track-rating-container">
            <div className='track-rating-title'>
                Track Rating
            </div>
            <div className='track-rating-content' style={{backgroundColor: backgroundColor}}>
                <div>
                    { ratingStr } 
                </div>
            </div>
           
            <LinearGaugeComponent 
                className='track-rating-component' 
                container={ { width:20, type:'RoundedRectangle', backgroundColor: Constants.darkBlue } } 
                background={Constants.grey} 
                orientation='Horizontal' 
                axisLabelRender={axisLabelRender}>
                <AxesDirective>
                    <AxisDirective 
                        maximum={10} 
                        minimum={1} 
                        majorTicks={{height: 0, interval: 1}} 
                        minorTicks={{height: 0}} 
                        labelStyle={{font: 
                            {
                                size: '12',
                                fontFamily: 'HandelGotDBol',
                                color: Constants.darkBlue
                            },
                            format: '{value}',
                            offset: 0
                        }}
                        line={{width: 0} }>
                        <PointersDirective>
                            <PointerDirective value={ rating } width={10} type='Bar' color={backgroundColor}>
                            </PointerDirective>
                        </PointersDirective>
                    </AxisDirective>
                </AxesDirective>
            </LinearGaugeComponent>
        </div>
    );
} 

function axisLabelRender(args: any) {
    if (args.text === '2') {
        args.text = 'Firm';
    } else if (args.text === '4') {
        args.text = 'Good';
    } else if (args.text === '7') {
        args.text = 'Soft';
    } else if (args.text === '9') {
        args.text = 'Heavy';
    } else {
        args.text = '';
    }

    // if (parseInt(args.text, 10) >= 0 && parseInt(args.text, 10) <= 2) {
    //     args.text = 'Firm';
    // } else if (parseInt(args.text, 10) > 2 && parseInt(args.text, 10) <= 4) {
    //     args.text = 'Good';
    // } else if (parseInt(args.text, 10) > 4 && parseInt(args.text, 10) <= 7) {
    //     args.text = 'Soft';
    // } else if (parseInt(args.text, 10) > 7 && parseInt(args.text, 10) <= 10) {
    //     args.text = 'Heavy';
    // } else {
    //     args.text = '';
    // }

}

export default TrackRating;